import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../../../injections/services.service';
import { ServiceService } from '../../../injections/service.service';
import { ActivatedRoute } from "@angular/router";
import * as moment from 'moment';
import { LoaderService } from '../../../common/loadingBar/loader.service';
import { UserService } from '../../../injections/user.service';

@Component({
  templateUrl: '../templates/main-service.html'
})
export class MainServiceComponent implements OnInit{
    public assignService: boolean = false;
    public cleanerData: object = {};
    public comments = [];
    public cleanersAvailability: Array<object>;
    public showModal: boolean = false;
    public showModalE: boolean = false;
    public showModalError: boolean = false;
    public showModalRecurrency: boolean = false;
    public showModalAssign: boolean = false;
    public userData: object = {};
    public editData: boolean;
    public userAddress: object = {};
    public headerData: object = {};
    public serviceData = {
      periodicity: null
    };
    public modalDataCancel: object = {};
    public clintuComment: object
    public profComment: object;
    public modalDataEmail: string;
    public modalDataRecurrency: object;
    public id: string;

    constructor(
        private servicesService: ServicesService, private serviceService: ServiceService, 
        private route: ActivatedRoute, public loaderService: LoaderService, private userService: UserService
      ){
        this.route.params.subscribe(params => {
          this.id = params["id"];
        });
        this.getServiceData();
    }

    public assignment(event){
      if(event == "assign"){
         this.assignService = true;
          this.serviceService.getCleanerForService(this.id, this.serviceData).subscribe(
           result => {
              //console.log(result);
              if(result.length == 0){
                this.cleanersAvailability = null;
              }else{
                this.cleanersAvailability = result;
              }
           }
         );
      }
      else if(event == "unassign"){
        if(this.serviceData["periodicty"] != "none"){
          this.showModalAssign = true;
        }else{

        } 
      }
      else if(event == "close"){
          this.assignService = false;
          //this.cleanerData = {};
          this.cleanersAvailability = null;
      }
    }

    public displayModal(event){
       if(event["action"] == "close"){
         this.showModal = false;
       }else if(event["action"] == "cancel"){
          this.modalDataCancel = event.data;
          this.serviceService.cancelService(this.id, event["reason"], event["penalized"]).subscribe(result => {
              this.showModal = false;
              if(result == "OK"){
                this.getServiceData();
              }else{
                this.displayModalError("open");
              }
          })
       }else if(event["action"] == "cancelAll"){
          this.modalDataCancel = event.data;
          this.serviceService.cancelAllServices(this.id, event["reason"], event["penalized"]).subscribe(result => {
              this.showModal = false;
              if(result == "OK"){
                this.getServiceData();
              }else{
                this.displayModalError("open");
              }
          })
       }else {
          this.showModal = true;
          this.modalDataCancel = event.data;
       }
    }

    public displayModalError(event) {
      if(event == "close"){
        this.showModalError = false;
      }else{
        this.showModalError = true;
      }

    }

    public displayModalRecurrency(event: object) {
      if(event["action"] == "close"){
        this.showModalRecurrency = false;
        if(event["data"] != null) {
          this.editService(event);
        }
      }else{
        this.showModalRecurrency = true;
      }

    }

    public displayModalAssign(event: object) {
      if(event["action"] == "close"){
          this.showModalAssign = false;
          if(event["data"] == "unAssignAll") this.unAssignAllServices()
          else if(event["data"] == "unAssign") this.unAssignService()
      }else{
        this.showModalAssign = true;
      }

    }

    public sendToApp(event: any) {
      
      this.servicesService.sendToAppWithProf(this.id, event).subscribe(status => {
        if(status == "OK"){
          this.cleanerData["ask_professional"] = event;
        }
        
      });
    }

    public assignCleaner(cleaner: object) {
      this.serviceService.assignService(this.id, cleaner["id_professional"]).subscribe(status => {
            if(status == "OK"){
              this.assignService = false;
              this.parseCleanerData(cleaner);
            }else{
              this.displayModalError("open");
            }
      })
    }

    public setDiscount(event: any) {
        this.serviceService.addDiscount(this.id, event["data"]).subscribe(result => {
          if(result == "OK"){
              this.serviceData = Object.assign(this.serviceData,{ periodicity: null});
              this.getServiceData();
          }else{
            this.displayModalError("open");
          }
        });  
    }

    public updateData(data) {
      let event = { action: "open", data: data}
      this.modalDataRecurrency = data;
      this.displayModalRecurrency(event);
    }

    private editService(data: object){
      this.serviceService.editService(this.id, data["data"], data["penalized"]).subscribe( resp => {
        if(resp.status == "OK"){
          this.getServiceData();
          this.editData = false;
        }else{
          this.displayModalError("open");
        }
      })
    }

    private unAssignService(){
      this.serviceService.unAssignService(this.id, this.cleanerData["cleaner_id"]).subscribe(
        result => {
          if(result == "OK"){
            this.getServiceData();
          }else{
            this.displayModalError("open");
          }
        },
        error => {
          console.error(`Error: ${error}`)
          this.displayModalError("open")
        });
    }

    private unAssignAllServices() {
      var date = moment(this.serviceData["date"],"DD/MM/YYYY").format("YYYY-MM-DD");
      var data = {
        options: {
          allServices: true
        },
        new_service: {
          id_service: parseInt(this.id),
          assignment_status: 0,
          id_professional: 0,
          ask_professional: 0,
          date: date
        },
        old_service: {
          id_service: parseInt(this.id),
          assignment_status: 2,
          id_professional: this.serviceData["id_professional"],
          ask_professional: 0,
          date: date
        }

      };
      
      this.serviceService.editService(this.id, data, "0").subscribe(
        result => {
          if(result["status"] == "OK"){
            this.getServiceData();
          }else{
            this.displayModalError("open");
          }
        },
        error => {
          console.error(`Error: ${error}`);
          this.displayModalError("open");
        });
    }

    public getServiceData() {
      this.serviceService.getServiceById(this.id).subscribe(result => {
        this.userService.getUserData(result["client"]["id_client"]).subscribe( data => {
          this.parseUserData(result["client"]);
          this.parseServiceData(result["service"], data, result["professional"]);
          this.parseCleanerData(result);
          this.parseHeaderData(result["service"]);
          this.parseUserAddress(result["client"]);
          this.parseComments(result["comments"]);
          var ins_date = moment(result["service"]["ins_date"]).format("DD/MM/YYYY");
          this.clintuComment = {
            text: result["clintuComment"],
            date: ins_date
          }
          this.profComment = {
            text: result["professionalComment"],
            date: ins_date
          }
          this.assignService = false;
        });
       
      });
    }

    public displayModalEmail(event) {
        this.showModalE = (event == "close") ? false : true;
        this.modalDataEmail = event;
    }

    private parseComments(comments: Array<object>){
        this.comments = comments;
        this.comments.forEach(element => {
            element["date"] = moment(element["ins_date"],"YYYY-MM-DDTHH:mm").format("DD/MM/YYYY");
            element["hour"] = moment(element["ins_date"],"YYYY-MM-DDTHH:mm").format("HH:mm");
        });
    }

    private parseUserData(object: object) {

        this.userData["name"] = object["client_name"];
        this.userData["surname"] = object["client_surname"];
        this.userData["phone"] = object["client_phone"];
        this.userData["email"] = object["client_email"];
        this.userData["contact_preference"] = this.getContactMethod(object["client_contact_preference"]);
        this.userData["cleaner_preference"] = (object["client_cleaner_preference"] == 0) ? "Enviar otra cleaner por defecto" : "Ponerse en contacto con el usuario";
        this.userData["userId"] = object["id_client"];
    }

    private parseUserAddress(object: object) {
      this.userAddress["client_address"] = object["client_address"];
      this.userAddress["client_floor"] = object["client_floor"];
      this.userAddress["client_city"] = object["client_city"];
      this.userAddress["client_door"] = object["client_door"];
      this.userAddress["client_number"] = object["client_number"];
      this.userAddress["zip_code"] = object["client_zip_code"];
    }

    private parseServiceData(object: object, client: object, cleaner: object) {
        this.serviceData["date"] = object["date"];
        this.serviceData["time_ini"] = object["time_ini"];
        this.serviceData["time_end"] = object["time_end"];
        this.serviceData["n_hours"] = object["n_hours"];
        this.serviceData["comments"] = object["comments"];
        this.serviceData["periodicity"] = object["periodicity"];
        this.serviceData["hour_price"] = object["hour_price"];
        this.serviceData["taxes"] = object["taxes"];
        this.serviceData["taxes_amount"] = object["taxes_amount"];
        this.serviceData["discount_code"] = object["discount_code"];
        this.serviceData["discount_type"] = object["discount_type"];
        this.serviceData["discount"] = object["discount"];
        this.serviceData["discount_amount"] = object["discount_amount"];
        this.serviceData["subtotal_amount"] = object["subtotal_amount"];
        this.serviceData["total_amount"] = object["total_amount"];
        this.serviceData["total_amount_real"] = object["total_amount_real"];
        this.serviceData["canceled"] = object["canceled"];
        this.serviceData["done"] = object["done"];
        this.serviceData["payment_method"] = object["payment_method"];
        this.serviceData["with_products"] = object["with_products"];
        this.serviceData["fee"] = object["fee"];
        this.serviceData["discount_hours_amount"] = (object["discount_hours_amount"] != "0.00") ? object["discount_hours_amount"] : 0;
        this.serviceData["discount_percent_amount"] = object["discount_percent_amount"] || 0;
        this.serviceData["discount_code"] = object["discount_code"];
        this.serviceData["mango_card_id"] = client["mango_card_id"];
        this.serviceData["client_mail"] = client["email"];

        if(object["transport_amount"] == "0" || object["transport_amount"] == "0.00" || object["transport_amount"] == "" 
        || object["transport_amount"] == null){
          this.serviceData["transport_amount"] = 0;
        }else{
          this.serviceData["transport_amount"] = object["transport_amount"];
        }
        if(object["discount_amount"] == "0" || object["discount_amount"] == "0.00" || object["discount_amount"] == "" 
        || object["discount_amount"] == null){
          this.serviceData["discount_amount"] = 0;
        }else{
          this.serviceData["discount_amount"] = object["discount_amount"];
        }
        if(object["fee"] != 0){
          var total = parseFloat(object["total_amount_real"]);
          this.serviceData["total_amount_present"] = total + object["fee"];
          this.serviceData["total_amount_present"] = this.serviceData["total_amount_present"].toFixed(2);
        }else{
            this.serviceData["total_amount_present"] = parseFloat(this.serviceData["total_amount_real"]).toFixed(2);
        }
        this.serviceData["id_professional"] = (cleaner["professional_id"] != null) ? cleaner["professional_id"] : 0;
    }

    private parseCleanerData(object: object) {
        //Seteo campos de la llamada getService
        if(typeof object["service"] != "undefined"){
          if(typeof object["professional"] != "undefined" && object["professional"]["professional_id"] != null){
            this.cleanerData["cleaner_id"] = object["professional"]["professional_id"];
            this.cleanerData["cleaner_name"] = object["professional"]["professional_name"];
            this.cleanerData["cleaner_surname"] = object["professional"]["professional_surname"];
            this.cleanerData["cleaner_phone"] = object["professional"]["professional_phone"];
            this.cleanerData["cleaner_email"] = object["professional"]["professional_email"];
          }
          else{
            this.cleanerData = {};
          }
          //Estos campos siempre tienen que enviarse al hijo
          this.cleanerData["ask_professional"] = object["service"]["ask_professional"];
          this.cleanerData["canceled"] = object["service"]["canceled"];
          this.cleanerData["done"] = object["service"]["done"];
        }
        //Setear cleaner al asignar viene del objeto cleaner
        else if(object["id_professional"] != null) {
          this.cleanerData["cleaner_id"] = object["id_professional"];
          this.cleanerData["cleaner_name"] = object["cleaner_full_name"];
          this.cleanerData["cleaner_phone"] = object["phone"];
          this.cleanerData["cleaner_email"] = object["email"];
          this.serviceData["id_professional"] = (object["id_professional"] != null) ? object["id_professional"] : 0;
        }
    }

    private parseHeaderData(object: object) {
        this.headerData["service_code"] = object["service_code"];
        this.headerData["canceled"] = object["canceled"];
        this.headerData["done"] = object["done"];
        this.headerData["periodicity"] = object["periodicity"];
        this.headerData["id"] = object["id"];
        this.headerData["office"] = object["office_name"];
        this.headerData["time_ini"] = object["time_ini"];
        this.headerData["time_end"] = object["time_end"];
        this.headerData["now"] = moment().format("HH:mm");
        this.headerData["today"] = object["today"];
        this.headerData["isAfter"] = object["isAfter"];
        this.headerData["isSame"] = object["isSame"];
        this.headerData["isBefore"] = object["isBefore"];
        this.headerData["date"] = object["date"];
        
    }

    private getContactMethod(value){
      let method;
      if(value == 0) method = "Email";
      else if(value == 1) method = "Teléfono";
      else if(value == 2) method = "Whatsapp";

      return method;
    }

    ngOnInit(){}
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/main-service.component.ts